/* eslint-disable no-underscore-dangle */
/* eslint-disable camelcase */
import _ from 'lodash';
import appConfig from 'app-config';
import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { MLProductCodeUtil, MLErrorMessageUtil } from 'ml-portals-util-js';
import { MLSortSubmissionService } from 'ml-portals-services-js'
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { platformMessages } from 'ml-components-platform-react';
import { MLPortalStorageService, MLSaveSessionService } from 'ml-services-common-react';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { withRetry } from './retryService';
import messages from './MLBundleService.messages';


const sendWithRetry = (endpoint, method, params, additionalHeaders) => withRetry(() => JsonRPCService.send(endpoint, method, params, additionalHeaders));

let sessionUUID;
const accountInfo = {};
const bundleJobs = [];
const prefillInfo = [];
const jobsToCreate = [];
const packageIndicatorRequoteJobs = [];
const postQuoteStatusStorageKey = 'BundlePostQuoteStatus';
const isGpa = appConfig.portalCode === 'GPA';

const customStatus = {
    'new': {
        'value': 'new',
        'displayName': 'Not Started'
    },
    'quotedWithIssue': {
        'value': 'quotewithissue',
        'displayName': 'Quoted with issues'
    },
    'readyForPostquote': {
        'value': 'readyforpostquote',
        'displayName': 'Purchase'
    },
    'postQuoteStarted': {
        'value': 'postquotestarted',
        'displayName': 'Purchase'
    },
    'postQuoteComplete': {
        'value': 'postquotecomplete',
        'displayName': 'Ready to issue'
    },
    'draft': {
        'value': 'draft',
        'displayName': 'Draft'
    },
    'quoted': {
        'value': 'quoted',
        'displayName': 'Quoted'
    },
    'requote': {
        'value': 'requote',
        'displayName': 'Requote'
    }

};

const getJob = (jobNumber) => {
    if (!_.isNil(jobNumber) && bundleJobs.length > 0) {
        return bundleJobs.find((job) => job.quoteID === jobNumber || job.jobNumber === jobNumber);
    }
};

const initFlags = () => {
    if (bundleJobs && bundleJobs.length > 0) {
        bundleJobs.forEach((job) => {
            job.postQuoteComplete = job.postQuoteComplete ? job.postQuoteComplete : false;
            job.readyForPostQuote = job.readyForPostQuote ? job.readyForPostQuote : false;
        });
    }
};

const _isPersonalAuto = (job) => MLProductCodeUtil.isPersonalAuto(job.product && job.product.publicID) ||
        MLProductCodeUtil.isPersonalAuto(job.productCode) ||
        (job.lobs && job.lobs.personalAuto);
const _isHomeOwners = (job) => MLProductCodeUtil.isHomeOwners(job.product && job.product.publicID) ||
        MLProductCodeUtil.isHomeOwners(job.productCode) ||
        (job.lobs && job.lobs.homeowners);
const _isPersonalUmbrella = (job) => MLProductCodeUtil.isPersonalUmbrella(job.product && job.product.publicID) ||
        MLProductCodeUtil.isPersonalUmbrella(job.productCode) ||
        (job.lobs && job.lobs.personalUmbrella);

const _clearPrefillData = () => {
    prefillInfo.splice(0, prefillInfo.length);
};

const sortJobs = (jobs) => {
    MLSortSubmissionService.sortSubmissions(jobs, _isPersonalAuto, _isHomeOwners, _isPersonalUmbrella);
};

const _refreshJobs = (jobs) => {
    const updatedjobs = [];

    jobs.forEach((newJobInfo) => {
        const jobToFind = newJobInfo.jobNumber || newJobInfo.quoteID;
        const oldJobInfo = getJob(jobToFind);

        if (oldJobInfo) {
            Object.assign(oldJobInfo, newJobInfo);
            updatedjobs.push(oldJobInfo);
        } else {
            updatedjobs.push(newJobInfo);
        }
    });
    bundleJobs.splice(0, bundleJobs.length, ...updatedjobs);
    sortJobs(bundleJobs);
};

const _setJobForPostQuote = (job) => {
    const savedSubPostQuote = MLSaveSessionService.getSessionValue(job.jobNumber);
    const isReadyToBind = savedSubPostQuote || false;

    job.postQuoteComplete = isReadyToBind;
    job.readyForPostQuote = !isReadyToBind;
};

const _getJobPostQuoteStatus = (job, additionalHeaders = {}) => MLPortalStorageService.retrieve(job.jobNumber, null, postQuoteStatusStorageKey, additionalHeaders);

const _getPostQuoteStatusForJobs = (additionalHeaders = {}) => {
    const promises = [];

    bundleJobs.forEach((job) => {
        promises.push(_getJobPostQuoteStatus(job, additionalHeaders));
    });

    return Promise.all(promises);
};

const _setJobForReview = (job) => {
    job.needsReview = true;
};

const _delay = (timeout) => new Promise((resolve) => {
        setTimeout(() => {
            resolve();
        }, timeout);
    });

const _setPrefillData = (prefillData) => {
    prefillInfo.splice(0, prefillData.length, ...prefillData);
};

const _getBundleSummary = (accountNumber, additionalHeaders = {}) => {
    const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

    return sendWithRetry(getProxiedServiceUrl(serviceName), 'getBundleSummary', [accountNumber, sessionUUID], additionalHeaders);
};

const _getBridgedQuoteSummaries = (submissionNumber, additionalHeaders = {}) => {
    const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

    return sendWithRetry(getProxiedServiceUrl(serviceName), 'getBridgedSummaries', [submissionNumber], additionalHeaders);
}

const _setIncludeStatuses = () => {
    bundleJobs.forEach((job) => {
        job.isIncluded = job.hasOwnProperty('isIncluded') ? job.isIncluded : true;
    });
};

const _setAccountHolder = () => {
    accountInfo.accountHolder = _.get(bundleJobs, '[0].accountHolder_ML');
};

const _clearBundleJobs = () => {
    bundleJobs.splice(0, bundleJobs.length);
};

const _refreshBundleSummary = (accountNumber, additionalHeaders = {}) => _getBundleSummary(accountNumber, additionalHeaders).then((bundleSummary) => {
        if (bundleSummary.jobSummaries && bundleSummary.jobSummaries.length > 0) {
            accountInfo.accountNumber = accountNumber;
            _refreshJobs(bundleSummary.jobSummaries);
            _setPrefillData(bundleSummary.prefillInfos);
            _setIncludeStatuses();
            _setAccountHolder();
        } else {
            _clearBundleJobs();
        }
    });

const _refreshBridgedQuoteSummaries = (submissionNumber, additionalHeaders = {}) => _getBridgedQuoteSummaries(submissionNumber, additionalHeaders).then((bridgedQuotes) => {
        if (bridgedQuotes.jobSummaries && bridgedQuotes.jobSummaries.length > 0) {
            // Account number will be the same for all quotes in a bundle, so we default to use
            // the first quote in the jobSummaries as tihs function will be used in monoline 
            // submission as well
            accountInfo.accountNumber = bridgedQuotes.jobSummaries[0].accountNumber;
            _refreshJobs(bridgedQuotes.jobSummaries);
            // Do not set prefill data as email address will be prefilled for drivers
            // _setPrefillData(bridgedQuotes.prefillInfos);
            _setIncludeStatuses();
            _setAccountHolder();
        } else {
            _clearBundleJobs();
        }
    });


const _getAccountHolder = () => accountInfo.accountHolder;

const _getAccountNumber = () => accountInfo.accountNumber;

const _validPrefillInfoHO = (info) => info.productType === 'HO' && info.occupation && info.occupationType && info.education;

const _validPrefillInfoPA = (info) => info.productType === 'PA' && info.occupation && info.occupationType && info.education;

const _validPrefillInfoPUP = (info) => info.occupation && info.occupationType;

const _validatePrefillEmail = (info) => info.emailAddress;

const _isBookrollBundle = () => bundleJobs && bundleJobs.some((job) => job.bookrollIndicator_ML === 'With Rate Capping' || job.bookrollIndicator_ML === 'Without Rate Capping');

const _isBookrollBundleWithoutRateCapping = () => bundleJobs && bundleJobs.some((job) => job.bookrollIndicator_ML === 'Without Rate Capping')

const _isBookrollBundleWithRateCapping = () => bundleJobs && bundleJobs.some((job) => job.bookrollIndicator_ML === 'With Rate Capping')

const _isBookrollWithIssues = (job) => (job.bookrollIndicator_ML === 'With Rate Capping' || job.bookrollIndicator_ML === 'Without Rate Capping') && job.hasIssues_ML;

const _getStatus = (submission) => {
    const {status} = submission;
    let statusToReturn = customStatus.draft;

    if (!_isBookrollBundle()) {
        if (status === 'Draft' && !submission.isStarted_ML) {
            statusToReturn = customStatus.new;
        } else if (status === 'Quoted' && submission.hasIssues_ML) {
            statusToReturn = customStatus.quotedWithIssue;
        } else if (status === 'Quoted' && submission.rateAsOfDateExpired_ML) {
            statusToReturn = customStatus.requote;
        } else if (status === 'Quoted' && !submission.hasIssues_ML && !submission.readyForPostQuote && !submission.postQuoteStarted && !submission.postQuoteComplete) {
            statusToReturn = customStatus.quoted;
        } else if (status === 'Quoted' && submission.readyForPostQuote && !submission.postQuoteStarted && !submission.postQuoteComplete) {
            statusToReturn = customStatus.readyForPostquote;
        } else if (status === 'Quoted' && !submission.readyForPostQuote && submission.postQuoteStarted && !submission.postQuoteComplete) {
            statusToReturn = customStatus.postQuoteStarted;
        } else if (status === 'Quoted' && !submission.readyForPostQuote && !submission.postQuoteStarted && submission.postQuoteComplete) {
            statusToReturn = customStatus.postQuoteComplete;
        }
    } else if (status === 'Quoted' && !submission.hasIssues_ML) {
        statusToReturn = customStatus.quoted;
    }

    return statusToReturn;
};

const _resetJobsToCreate = () => {
    jobsToCreate.splice(0, jobsToCreate.length);
};

const _resetPackageIndicatorRequoteJobs = () => {
    packageIndicatorRequoteJobs.splice(0, packageIndicatorRequoteJobs.length);
};

const _getLobLabel = (job, getPolicyTypeName) => {
    let lobLabel = '';

    if (_isHomeOwners(job)) {
        if (job.productType) {
            lobLabel = _.lowerCase(getPolicyTypeName(job.productType));
        } else {
            lobLabel = _.lowerCase(getPolicyTypeName(job.product.coveragePartType_ML));
        }
    } else if (job.productCode) {
        lobLabel = _.lowerCase(getPolicyTypeName(job.productCode));
    } else {
        lobLabel = _.lowerCase(getPolicyTypeName(job.product.publicID));
    }

    return lobLabel;
};

const _isJobForPostQuote = (jobNumber) => {
    const currentJob = getJob(jobNumber);

    return currentJob ? !!currentJob.readyForPostQuote || !!currentJob.postQuoteStarted || !!currentJob.postQuoteComplete : false;
};

const _getProgressMessage = (quoteId, getPolicyTypeName) => {
    let message = platformMessages.retrievingDraftSubmission;

    const currentJob = getJob(quoteId);
    const idxOfCurrentJob = bundleJobs.indexOf(currentJob);

    if (_isBookrollBundle()) {
        message = platformMessages.retrievingQuotedSubmission;
    } else if (idxOfCurrentJob === 0 && !_isJobForPostQuote(currentJob.jobNumber)) {
        const firstLobLabel = _getLobLabel(currentJob, getPolicyTypeName);
        const secondLobLabel = _getLobLabel(bundleJobs[1], getPolicyTypeName);

        message = {
            ...messages.twoJobsMessage, args: {
                firstJob: firstLobLabel,
                secondJob: secondLobLabel
            }
        };
    } else if (idxOfCurrentJob !== 0 && !_isJobForPostQuote(currentJob.jobNumber)) {
        const lobLabel = _getLobLabel(currentJob, getPolicyTypeName);

        message = {
            ...messages.completeStepsForJob, args: {
                job: lobLabel
            }
        };
    } else {
        message = messages.completeStepsForPurchase;
    }

    return message;
};

const _getCreationProgressMessage = (getPolicyTypeName) => {
    const firstLobLabel = _getLobLabel(jobsToCreate[0], getPolicyTypeName);
    const secondLobLabel = _getLobLabel(jobsToCreate[1], getPolicyTypeName);
    const message = {
        ...messages.twoJobsMessage, args: {
            firstJob: firstLobLabel,
            secondJob: secondLobLabel
        }
    };

    return message;
};

const _getIssuedBundlePolicies = (accountNumber, additionalHeaders = {}) => {
    const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

    return sendWithRetry(getProxiedServiceUrl(serviceName), 'getIssuedBundlePolicies', [accountNumber], additionalHeaders).then((issuedJobs) => {
        sortJobs(issuedJobs);

        return issuedJobs;
    });
};

const _waitForJobsToBeBundled = (numRetries, numJobs) => {
    if (!numRetries) {
        throw new Error('Too many retries');
    }

    return _getIssuedBundlePolicies(accountInfo.accountNumber)
        .then((policies) => {
            if (policies.length === numJobs) {
                return policies;
            }

            return _delay(10000).then(() => _waitForJobsToBeBundled(--numRetries, numJobs));
        });
};

const _isQuotedOrQuotedWithIssues = (jobNumber) => {
    const currentJob = getJob(jobNumber);

    return currentJob ? (_getStatus(currentJob) === customStatus.quoted) || (_getStatus(currentJob) === customStatus.quotedWithIssue) : false;
};

const _isRequoteNeeded = (job) => _getStatus(job) === customStatus.requote;

const _startBundle = (submissions, additionalHeaders = {}) => {
    const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

    submissions.forEach((sub) => {
        if (sub.productCode === 'PersonalAuto') {
            sub.PolicyTerm_Ext = 'HalfYear';
        }
    });

    return sendWithRetry(getProxiedServiceUrl(serviceName), 'createOrUpdateBundle', [submissions], additionalHeaders).then(() => {
        _clearBundleJobs();
        _clearPrefillData();
    });
};

const _gotoBundleCart = (accountNumber, history) => {
    const agentBundleCartInfo = {
        accountNumber,
        hasExistingSubmissions_ML: true,
        isBundleRetrieval_Ext: true
    };

    history.push(`/agent-bundle-cart/${agentBundleCartInfo.accountNumber}`, agentBundleCartInfo);
};

const _showErrorMessage = (error, showError, history, accountNumber) => {
    const modalTitle = platformMessages.error;

    const displayErrorMessage = MLErrorMessageUtil.retrieveDisplayableErrorMessage(error);

    if (displayErrorMessage) {
        showError(modalTitle, displayErrorMessage);
    }

    if  (history && accountNumber) {
        const params = {
            accountNumber
        };

        history.push('/contactUs', params);
    }
};

const _loadBundleCart = (accountNumber, history) => {
    _clearBundleJobs();
    _clearPrefillData();
    _gotoBundleCart(accountNumber, history);
};

const _getPostQuoteStatusJson = (job) => ({ 'jobNumber': job.jobNumber, 'readyForPostQuote': job.readyForPostQuote, 'postQuoteStarted': job.postQuoteStarted, 'postQuoteComplete': job.postQuoteComplete });

const _resetPostQuoteStatusForJob = (jobNumber, additionalHeaders = {}) => {
    const currentJob = getJob(jobNumber);

    if (currentJob) {
        currentJob.readyForPostQuote = false;
        currentJob.postQuoteStarted = false;
        currentJob.postQuoteComplete = false;
        MLPortalStorageService.store(jobNumber, null, postQuoteStatusStorageKey, JSON.stringify(_getPostQuoteStatusJson(currentJob)), additionalHeaders);
    }
};

const _setJobReadyForPostQuote = (jobNumber, additionalHeaders = {}) => {
    const currentJob = getJob(jobNumber);

    if (currentJob) {
        currentJob.readyForPostQuote = true;
        currentJob.postQuoteStarted = false;
        currentJob.postQuoteComplete = false;
        MLPortalStorageService.store(jobNumber, null, postQuoteStatusStorageKey, JSON.stringify(_getPostQuoteStatusJson(currentJob)), additionalHeaders);
    }
};

const _setJobPostQuoteStarted = (jobNumber, additionalHeaders = {}) => {
    const currentJob = getJob(jobNumber);

    if (currentJob) {
        currentJob.readyForPostQuote = false;
        currentJob.postQuoteStarted = true;
        currentJob.postQuoteComplete = false;
        MLPortalStorageService.store(jobNumber, null, postQuoteStatusStorageKey, JSON.stringify(_getPostQuoteStatusJson(currentJob)), additionalHeaders);
    }
};

const _setJobPostQuoteComplete = (jobNumber, additionalHeaders = {}) => {
    const currentJob = getJob(jobNumber);

    if (currentJob) {
        currentJob.readyForPostQuote = false;
        currentJob.postQuoteStarted = false;
        currentJob.postQuoteComplete = true;
        MLPortalStorageService.store(jobNumber, null, postQuoteStatusStorageKey, JSON.stringify(_getPostQuoteStatusJson(currentJob)), additionalHeaders);
    }
};

const _getFormatCurrency = (value, intl) => {
    let formattedAmount = '';

    if (value) {
        const { amount, currency } = value;

        if (!_.isUndefined(amount) && currency) {
            formattedAmount = intl.formatNumber(
                amount,
                {
                    style: 'currency',
                    currency
                }
            );
        }
    }

    return formattedAmount;
};

const _checkIsCRBridgedQuote = (quoteId, authHeader) => {
    const bridgedQuotePromise = _getBridgedQuoteSummaries(quoteId, authHeader);
    let isCRBridgeQuote;

    return bridgedQuotePromise.then(
        (bridgedQuotesResp) => {
            // Is CR Bridged Quote
            if (bridgedQuotesResp 
                && bridgedQuotesResp.jobSummaries 
                && bridgedQuotesResp.jobSummaries.length > 0) {
                isCRBridgeQuote = bridgedQuotesResp.jobSummaries;
            } else {
                isCRBridgeQuote = false;
            }

            return isCRBridgeQuote;
        },
        (error) => {
            console.error(error);
        }
    );
}

 const _resetPostQuoteStatusForAllJobs = () => {
        bundleJobs.forEach((job) => {
            job.readyForPostQuote = false;
            job.postQuoteStarted = false;
            job.postQuoteComplete = false;
        });
    };


const _updateBundleCartEffectiveDate = (bundleCartPayload, additionalHeaders = {}) => {
    const serviceName = isGpa ? 'gatewaybundling' : 'bundling';
    const { jobNumber, isFromCompRater, effectiveDate } = bundleCartPayload;

    return sendWithRetry(getProxiedServiceUrl(serviceName), 'updateBundleCartEffectiveDate', [jobNumber, effectiveDate, isFromCompRater], additionalHeaders).then((bundleSummary) => {
        if (bundleSummary.jobSummaries && bundleSummary.jobSummaries.length > 0) {
            accountInfo.accountNumber = bundleSummary.jobSummaries[0].accountNumber;;
            _refreshJobs(bundleSummary.jobSummaries);
            _setPrefillData(bundleSummary.prefillInfos);
            _resetPostQuoteStatusForJob(jobNumber,additionalHeaders);
            _resetPostQuoteStatusForAllJobs();
            _setIncludeStatuses();
            _setAccountHolder();
        } else {
            _clearBundleJobs();
        }
    })

}



export default {
    checkIsCRBridgedQuote: _checkIsCRBridgedQuote,

    getAccountHolder: _getAccountHolder,

    getAccountNumber: _getAccountNumber,

    getBundleSummary: _getBundleSummary,

    getBridgedQuoteSummaries: _getBridgedQuoteSummaries,

    refreshBundleSummary: _refreshBundleSummary,

    refreshBridgedQuoteSummaries: _refreshBridgedQuoteSummaries,

    getStatus: _getStatus,

    isJobForPostQuote: _isJobForPostQuote,

    startBundle: _startBundle,

    isBookrollBundle: _isBookrollBundle,

    isBookrollBundleWithoutRateCapping: _isBookrollBundleWithoutRateCapping,

    isBookrollBundleWithRateCapping: _isBookrollBundleWithRateCapping,

    loadBundleCart: _loadBundleCart,

    showErrorMessage: _showErrorMessage,

    updateBundleCartEffectiveDate : _updateBundleCartEffectiveDate,

    addBundleJobs: (jobs) => {
        if (jobs) {
            bundleJobs.push(...jobs);
            initFlags();
        }
    },

    clearBundleJobs: _clearBundleJobs,

    getPostQuoteStatusForJobs: (additionalHeaders = {}) => {
        return _getPostQuoteStatusForJobs(additionalHeaders);
    },

    resetPostQuoteStatusForJob: (jobNumber, additionalHeaders = {}) => {
        _resetPostQuoteStatusForJob(jobNumber, additionalHeaders);
    },

    setJobReadyForPostQuote: (jobNumber, additionalHeaders = {}) => {
        _setJobReadyForPostQuote(jobNumber, additionalHeaders);
    },

    setJobPostQuoteStarted: (jobNumber, additionalHeaders = {}) => {
        _setJobPostQuoteStarted(jobNumber, additionalHeaders);
    },

    setJobPostQuoteComplete: (jobNumber, additionalHeaders = {}) => {
        _setJobPostQuoteComplete(jobNumber, additionalHeaders);
    },

    isJobPostQuoteStarted: (jobNumber) => {
        const currentJob = getJob(jobNumber);

        return currentJob ? !!currentJob.postQuoteStarted : false;
    },

    isJobPostQuoteComplete: (jobNumber) => {
        const currentJob = getJob(jobNumber);

        return currentJob ? !!currentJob.postQuoteComplete : false;
    },

    setPaymentDetailsForJob: (jobNumber, paymentDetails) => {
        const currentJob = getJob(jobNumber);

        if (currentJob) {
            currentJob.paymentChannel_ML = paymentDetails.paymentChannel_ML.value;
        }
    },

    setJobStatus: (jobNumber, status) => {
        const currentJob = getJob(jobNumber);

        if (currentJob) {
            currentJob.status = status;
        }
    },
    getJobs: () => {
        return bundleJobs;
    },

    formatPremium: (premium, intl) => {
        return (!premium || premium.amount === 0) ? '$ --' : _getFormatCurrency(premium, intl);
    },

    formatSubmissionPremium: (submission, intl) => {
        return submission.totalPremium.amount === 0 || _isBookrollWithIssues(submission) ? '$ --' : _getFormatCurrency(submission.totalPremium, intl);
    },

    inPostQuote: () => {
        return bundleJobs && bundleJobs.some((x) => x.readyForPostQuote || x.postQuoteStarted || x.postQuoteComplete);
    },

    moveToPostQuote: (accountNumber, extraArgs, additionalHeaders = {}) => {
        let promise = null;
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        if (isGpa) {
            promise = sendWithRetry(getProxiedServiceUrl(serviceName), 'validatePostQuote', [accountNumber], additionalHeaders);
        } else {
            promise = sendWithRetry(getProxiedServiceUrl(serviceName), 'validatePostQuote', [accountNumber, extraArgs], additionalHeaders);
        }

        return promise.then((canMovePostQuote) => {
            if (canMovePostQuote) {
                bundleJobs.forEach((job) => {
                    _setJobForPostQuote(job);
                });
            }

            return canMovePostQuote;
        });
    },

    canMoveToPostQuote: (accountNumber, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'validatePostQuote',
            [accountNumber], additionalHeaders);
    },

    startIssuance: (accountNumber, additionalHeaders = {}) => {
        let retry = 20;

        const waitForJobsToBeBundled = () => {
            if (!retry--) {
                throw new Error('Too many retries');
            }

            return _getBundleSummary(accountNumber, additionalHeaders)
                .then((summary) => {
                    if (summary.jobSummaries.length === 0) {
                        return Promise.resolve();
                    }

                    return _delay(5000).then(waitForJobsToBeBundled);
                });
        };
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'issueBundle',
            [accountNumber], additionalHeaders).then(() => waitForJobsToBeBundled());
    },

    getIssuedBundlePolicies: _getIssuedBundlePolicies,

    removeJobsFromBundle: (jobs, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'removeSubmissionsFromBundle',
            [jobs], additionalHeaders);
    },

    addJobToBundle: (jobNumber, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'addSubmissionToBundle',
            [jobNumber], additionalHeaders);
    },

    markJobsForPrequote: (saveStatus, additionalHeaders = {}) => {
        bundleJobs.forEach((job) => {
            job.readyForPostQuote = false;
            job.postQuoteStarted = false;
            job.postQuoteComplete = false;

            if (saveStatus) {
                MLPortalStorageService.store(job.jobNumber, null, postQuoteStatusStorageKey, JSON.stringify(_getPostQuoteStatusJson(job)), additionalHeaders);
            }
        });
    },

    getPrefillDriversCandidate: () => {
        if (prefillInfo && prefillInfo.length > 0) {
            const candidates = prefillInfo.filter((info) => info.driverDetails && info.driverDetails.length > 0);

            if (candidates && candidates.length > 0) {
                return candidates[0];
            }
        }

        return null;
    },

    getPrefillCandidateForJobType: (jobNumber, productType) => {
        if (prefillInfo && prefillInfo.length > 0) {
            const candidates = prefillInfo.filter((info) => {
                if (info.jobNumber !== jobNumber) {
                    if (productType === 'HO') {
                        return _validPrefillInfoHO(info);
                    }

                    if (productType === 'PA') {
                        return _validPrefillInfoPA(info);
                    }

                    if (productType === 'PUP') {
                        return _validPrefillInfoPUP(info);
                    }
                }

                return undefined;
            });

            if (candidates && candidates.length > 0) {
                return candidates[0];
            }
        }

        return null;
    },

    getPrefillEmailCandidate: () => {
        if (prefillInfo && prefillInfo.length > 0) {
            const candidates = prefillInfo.filter((info) => _validatePrefillEmail(info));

            if (candidates && candidates.length > 0) {
                return candidates[0];
            }
        }

        return null;
    },

    isDraft: (job) => _getStatus(job) === customStatus.draft,

    isNotStarted: (job) => _getStatus(job) === customStatus.new,

    isQuoted: (job) => _getStatus(job) === customStatus.quoted,

    isQuotedWithIssues: (job) => _getStatus(job) === customStatus.quotedWithIssue,

    isPrePurchase: (job) => _getStatus(job) === customStatus.readyForPostquote,

    isPurchaseStarted: (job) => _getStatus(job) === customStatus.postQuoteStarted,

    isReadyToIssue: (job) => _getStatus(job) === customStatus.postQuoteComplete,

    isRequoteNeeded: _isRequoteNeeded,

    isRequoteNeededForJobNumber: (jobNumber) => {
        const job = getJob(jobNumber);

        return job ? _getStatus(job) === customStatus.requote : false;
    },

    addJobsToCreate: (jobs) => {
        _resetJobsToCreate();
        jobsToCreate.push(...jobs);
    },

    resetJobsToCreate: () => {
        _resetJobsToCreate();
    },

    getJobsToCreate: () => jobsToCreate,

    createBundleSubmissions: (bundlesToCreate, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'createBundleOnNewAccount',
            [bundlesToCreate], additionalHeaders);
    },

    getProgressMessage: _getProgressMessage,

    getCreationProgressMessage: _getCreationProgressMessage,

    moveToReview: () => {
        bundleJobs.forEach((job) => {
            _setJobForReview(job);
        });
    },

    moveAllOtherJobsToReview: (jobNumber) => {
        bundleJobs.forEach((job) => {
            if (job.quoteID !== jobNumber && job.jobNumber !== jobNumber) {
                if (job.isStarted_ML) {
                    _setJobForReview(job);
                }
            }
        });
    },

    getJobsToReview: () => bundleJobs.filter((job) => job.needsReview),

    markJobReviewed: (job) => {
        job.needsReview = false;
    },

    setSessionUUID: (aSessionUUID) => {
        if (aSessionUUID) {
            sessionUUID = aSessionUUID;
        }
    },

    isQuotedOrQuotedWithIssues: _isQuotedOrQuotedWithIssues,

    setPackageIndicatorRequoteJobs: () => {
        _resetPackageIndicatorRequoteJobs();
        bundleJobs.forEach((job) => packageIndicatorRequoteJobs.push(job.publicID));
    },

    removePackageIndicatorRequoteJob: (id) => {
        const pkgInd = packageIndicatorRequoteJobs.indexOf(id);

        if (pkgInd > -1) {
            packageIndicatorRequoteJobs.splice(pkgInd, 1);
        }
    },

    getNumberPackageIndicatorRequotes: () => packageIndicatorRequoteJobs.length,

    getPackageIndicatorRequoteId: (index) => packageIndicatorRequoteJobs.length > index ? packageIndicatorRequoteJobs[index] : '',

    requoteSubmission: (submissionNumber, additionalHeaders = {}) => {
        _setJobReadyForPostQuote(submissionNumber, additionalHeaders);

        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'requoteSubmission',
            [submissionNumber], additionalHeaders);
    },

    hasQuotedUmbrellaJob: () => bundleJobs.some((job) => {
            const quoteID = job.quoteID ? job.quoteID : job.jobNumber;

            return _isPersonalUmbrella(job) && (_isQuotedOrQuotedWithIssues(quoteID) || _isRequoteNeeded(job));
        }),

    resetUmbrellaToDraftStatus: (accountNumber, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'resetUmbrellaToDraftStatus',
            [accountNumber], additionalHeaders);
    },

    resetPostQuoteStatusForAllJobs:_resetPostQuoteStatusForAllJobs,

    updateBundleAndGotoAgentBundleCart: (accountNumber, quoteID, showProgressDialog, viewModelService, showError, history, authHeader) => {
        const quotesPromise = LoadSaveService.getAllBundledQuotes(quoteID, authHeader);

        showProgressDialog(messages.retrievingBundleDetails, quotesPromise);
        quotesPromise.then((submissions) => {
            if (submissions.length > 1) {
                const bundledQuotes = submissions.map((submission) => viewModelService.create({
                        accountNumber,
                        effectiveDate: submission.baseData.periodStartDate,
                        jobNumber: submission.quoteID,
                        postalCode_ML: submission.baseData.policyAddress.postalCode,
                        productCode: submission.baseData.productCode,
                        bundleID: submission.bundleID_ML,
                        producerCode: submission.producerCodeOfRecord_ML.code,
                        state: submission.baseData.policyAddress.state,
                        country: submission.baseData.policyAddress.country,
                        producerContactFirstName_ML: submission.producerCodeOfRecord_ML.producerContactFirstName_ML,
                        producerContactLastName_ML: submission.producerCodeOfRecord_ML.producerContactLastName_ML,
                        isSubmitAgent: true,
                        included: true,
                        termType: submission.baseData.termType
                    },
                    'pc',
                    'metlife.edge.capabilities.bundling.dto.NewBundledSubmissionDTOML'
                    ).value);

                _startBundle(bundledQuotes, authHeader).then(() => {
                    _gotoBundleCart(accountNumber, history);
                }).catch((error) => {
                    console.error(error);
                    _showErrorMessage(error, showError, history, accountNumber);
                });
            } else {
                _gotoBundleCart(accountNumber, history);
            }
        }, (error) => {
            _showErrorMessage(error, showError, history, accountNumber);
        });
    },
    setJobPostQuoteStatus: (jobNumber, isComplete) => {
        const currentJob = getJob(jobNumber);

        if (currentJob) {
            currentJob.postQuoteComplete = isComplete;
            currentJob.readyForPostQuote = !isComplete;
        }
    },

    removeJobFromBundle: (jobNumber, additionalHeaders = {}) => {
        const serviceName = isGpa ? 'gatewaybundling' : 'bundling';
        
        _resetPostQuoteStatusForJob(jobNumber,additionalHeaders)

        return sendWithRetry(getProxiedServiceUrl(serviceName), 'removeSubmissionFromBundle',
            [jobNumber], additionalHeaders);
    },

    setPremiumForJob: (jobNumber, premium) => {
        const currentJob = getJob(jobNumber);

        if (currentJob) {
            currentJob.totalPremium = premium;
        }
    }
};